import React from 'react';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import SimplePicker from 'Helpers/SimplePicker';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import WizardStandardHeader from 'Components/ComponentLibrary/Components/Uncategorized/WizardStandardHeader';
import { useNavigationContext } from 'Organisms/NavigationWithContext/NavigationContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import IncludedRelationshipContent from './IncludedRelationshipContent';

const ScenarioActivationAccountOpeningInterstitialTemplateContent = () => {
  const { resource } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { pageContentResource, setPageContentCollection } = usePageContentContext();
  const { navigationCollection } = useNavigationContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleGetStarted = async (actionResource) => {
    logStandardizedEvent(categories.activation, eventTypes.clickButton, 'action clicked', {
      eventProperties: {
        accountName: actionResource.attr('title'),
        selectedActionId: actionResource.id(),
      },
    });
    pageContentResource.attr('selectedAction', actionResource.id());
    let nextStepColl;
    try {
      nextStepColl = await pageContentResource.submit();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
    if (nextStepColl) {
      setPageContentCollection(nextStepColl);
    }
  };

  return (
    <Box paddingY={2}>
      <FDContentContainer maxWidth={'sm'}>
        <FDStack
          spacing={4}
          direction={'column'}
          alignItems={'center'}
          justifyContent="flex-start"
        >
          <FDStack
            spacing={2}
            direction={'column'}
            alignItems={'center'}
            justifyContent="flex-start"
          >
            <WizardStandardHeader
              title={resource.attr('moduleName')}
              navigationExists={!!navigationCollection}
            />
            <PageContentTop
              badgeImage={resource.attr('imageUrl')}
              title={resource.attr('title')}
              subtitle={resource.attr('subtitle')}
            />
          </FDStack>
          <SimplePicker
            resource={resource}
            relationship={fr.relationships.activationActions.name}
            hasRelationship={({ relationship }) => (
              <FDContentContainer maxWidth={'xs'}>
                <IncludedRelationshipContent
                  resource={resource}
                  relationship={relationship}
                  onActionClick={(res) => handleGetStarted(res)}
                  showAction={(res) => res.attr('status') === 'todo'}
                />
              </FDContentContainer>
            )}
          />
        </FDStack>
      </FDContentContainer>
    </Box>
  );
};

export default ScenarioActivationAccountOpeningInterstitialTemplateContent;
